export const FinishSpecs = ({ finish }) => {
  const specs = [
    ["Material", finish.material], ["Surface / finish", finish.finish],
    ["Colour", finish.tone], ["Catalog sizes", finish.size || "Not specified — confirm on enquiry"],
    ["Thickness", finish.thickness || "Confirm available thicknesses on enquiry"],
    ["Applications", finish.applications],
  ];
  return (
    <div>
      <h2 className="font-heading text-lg border-b border-bone/20 pb-4" data-testid="finish-specifications-heading">Stone specifications</h2>
      <dl data-testid="finish-specifications">
        {specs.map(([label, value], index) => (
          <div key={label} className="grid grid-cols-[100px_minmax(0,1fr)] sm:grid-cols-[125px_minmax(0,1fr)] gap-4 border-b border-bone/10 py-4 text-sm" data-testid={`finish-spec-${index}`}>
            <dt className="text-bone/50">{label}</dt><dd className="text-bone/90 leading-relaxed">{value}</dd>
          </div>
        ))}
      </dl>
      <p className="text-xs leading-relaxed text-bone/50 mt-5" data-testid="finish-specification-note">
        Garg Stone Company catalog · pp. {finish.page}. Natural colour and texture vary. Confirm size, thickness, availability and suitability with our team before ordering.
      </p>
    </div>
  );
};